import { h, ComponentChild, Fragment } from "preact";

// TODO-electron-tech-debt-onur: This is a blasphemy, literally to our conventions of separation of modules.
// Let's discuss a way to remove mapper (therefore stores) dependency from Markdown and AvatarPreviewPopover.
import AvatarPreviewPopover, { AvatarPreviewPopoverProps } from "../../../apps/containers/AvatarPreviewPopover";

import UserAvatar from "../../../apps/containers/UserAvatar";
import User from "../../../foundation/api/model/users/User";
import classname from "../../../foundation/utils/classname";
import permissions from "../../../foundation/utils/permissions";
import { getUserDisplayName } from "../../../foundation/utils/user";
import { AvatarProps } from "../Avatar";

import styles from "./UserStack.module.css";

const MAX_VISIBLE_USER_COUNT = 4;

type StackUser = User & Pick<AvatarProps, "highlight" | "accessory" | "accessoryLocation">;

interface Props {
    class?: string;
    users: StackUser[];
    role?: string;
    maxVisibleUserCount?: number;
    children?: ComponentChild;
    showPreview?: boolean;
    previewOptions?: Pick<AvatarPreviewPopoverProps, "position">;
}

function UserStack({
    class: cssClass,
    users,
    role,
    maxVisibleUserCount = MAX_VISIBLE_USER_COUNT,
    showPreview = false,
    children,
    previewOptions = {}
}: Props) {
    const visibleUsers = users.slice(0, maxVisibleUserCount);
    const otherUsers = users.slice(maxVisibleUserCount);

    const VisibleUserAvatar = ({
        user,
        ...props
    }: { user: StackUser; } & Partial<AvatarProps>) => (
        <UserAvatar
            user={user}
            highlight={user.highlight}
            accessory={user.accessory}
            accessoryLocation={user.accessoryLocation}
            {...props}/>
    );

    function getTitle(user: User) {
        // TODO-electron-tech-debt-onur: this doesn't make a difference, email is shown with dummy data, check data and update dummy data in storybook
        const showEmail = role && permissions.canSeeOthersEmail(role);
        if (user.status !== "invited") {
            return getUserDisplayName(user) + (showEmail ? ` (${user.email})` : "");
        }

        return `Pending… (${user.email})`;
    }

    function renderOtherUsers() {
        const text = `+${otherUsers.length}`;
        const title = otherUsers.map(user => getTitle(user)).join("\n");
        return (
            <span
                class={classname(styles.otherUsers, "caption-1")}
                title={title}>
                {text}
            </span>
        );
    }

    return (
        <div class={classname(styles.userStack, cssClass)}>
            {visibleUsers.map(user => {
                if (showPreview) {
                    return (
                        <AvatarPreviewPopover
                            key={user._id}
                            class={styles.avatarContainer}
                            member={{ user }}
                            {...previewOptions}>
                            <VisibleUserAvatar user={user}/>
                        </AvatarPreviewPopover>
                    );
                }

                return (
                    <VisibleUserAvatar
                        key={user._id}
                        class={styles.avatarContainer}
                        title={getTitle(user)}
                        user={user}/>
                );
            })}
            {!!otherUsers.length && renderOtherUsers()}
            {children}
        </div>
    );
}

export default UserStack;
export {
    StackUser,
    Props as UserStackProps
};
